import { useMemo } from 'react'

import { NotesTextEditor, NotesTextEditorSkeleton } from '@factorialco/f0-react/dist/experimental'
import { PagesPageVersionPreviewDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { useNotesTextEditor } from 'modules/pages/lib/hooks/useNotesTextEditor'

interface VersionPageProps {
  pageId: number
  versionId: number
  isloadingVersions: boolean
}

export const VersionPage = ({ pageId, versionId, isloadingVersions }: VersionPageProps) => {
  const { toolbarLabels, titlePlaceholder, placeholder } = useNotesTextEditor()
  const { data, loading } = useQuery(PagesPageVersionPreviewDocument, {
    variables: {
      pageId,
      versionId,
    },
    skip: !pageId || !versionId,
  })

  const version = data?.handbookPages.pageVersionsConnection.nodes[0]

  const editorConfig = useMemo(
    () => ({
      labels: { toolbarLabels, titlePlaceholder },
      placeholder,
      initialEditorState: {
        content:
          version && version.content && version.content.trim() !== ''
            ? JSON.parse(version.content)
            : undefined,
        title: version?.title,
      },
    }),
    [toolbarLabels, titlePlaceholder, placeholder, version]
  )

  if (loading || isloadingVersions) {
    return <NotesTextEditorSkeleton withPadding withHeader={false} withTitle withToolbar={false} />
  }

  return <NotesTextEditor key={versionId} {...editorConfig} readonly onChange={() => {}} />
}
